document.addEventListener('DOMContentLoaded', function() {
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.owlCarousel === 'undefined') return;
    var $ = jQuery;
    
    $('.product-card__slider').each(function() {
        const $slider = $(this).find('.product-card__track.owl-carousel');
        // const $prevBtn = $(this).find(".owl-nav-left-rni");
        // const $nextBtn = $(this).find(".owl-nav-right-rni");
        
        $slider.owlCarousel({
            items: 1,
            loop: true,
            dots: false,
            nav: true,
            navText:[
                `<button class="owl-nav-left-rni owl-nav-rni">
                  <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.82184 5.24144C1.87966 5.29111 1.92623 5.32643 1.96736 5.36756C3.34652 6.74284 4.72645 8.11734 6.10096 9.49727C6.18516 9.58187 6.25385 9.70023 6.28412 9.81471C6.33185 9.99476 6.22281 10.1869 6.05943 10.2796C5.8949 10.3731 5.69 10.3588 5.5406 10.2404C5.49908 10.2074 5.46221 10.1682 5.42457 10.1306C3.9224 8.6319 2.42022 7.13284 0.918051 5.63377C0.629336 5.34583 0.629336 5.11183 0.916499 4.82505C2.42527 3.31939 3.93326 1.81256 5.44591 0.310386C5.53051 0.226177 5.64848 0.156715 5.76335 0.12567C5.94302 0.076387 6.13705 0.184267 6.23134 0.346087C6.32603 0.509072 6.31284 0.715131 6.19487 0.864533C6.15916 0.909936 6.11609 0.949906 6.07496 0.990652C4.70007 2.36321 3.32479 3.73539 1.94951 5.10795C1.91226 5.14481 1.87733 5.18362 1.82184 5.24144Z" fill="#1E3142"></path>
                  </svg>
                </button>`,
                `<button class="owl-nav-right-rni owl-nav-rni">
                  <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.63275 5.21327C4.57493 5.1636 4.52836 5.12829 4.48723 5.08715C3.10807 3.71187 1.72814 2.33737 0.353635 0.957438C0.269426 0.872842 0.20074 0.754483 0.170471 0.640006C0.12274 0.459947 0.231785 0.267859 0.395157 0.175113C0.559694 0.0815908 0.764588 0.0959492 0.913991 0.214307C0.955513 0.247292 0.992379 0.286486 1.03002 0.324127C2.53219 1.82281 4.03437 3.32188 5.53654 4.82095C5.82525 5.10888 5.82525 5.34288 5.53809 5.62966C4.02932 7.13532 2.52133 8.64215 1.00868 10.1443C0.924079 10.2285 0.806109 10.298 0.691244 10.329C0.511573 10.3783 0.317544 10.2704 0.223246 10.1086C0.12856 9.94564 0.141754 9.73958 0.259724 9.59018C0.295425 9.54478 0.338499 9.50481 0.379634 9.46406C1.75452 8.0915 3.1298 6.71933 4.50508 5.34676C4.54233 5.3099 4.57726 5.27109 4.63275 5.21327Z" fill="#1E3142"></path>
                  </svg>
                </button>`
            ],
            autoplay: true,
            smartSpeed: 400
        });

        // // Attach after initialization; buttons must exist!
        // $prevBtn.on('click', function(e) {
        //     e.preventDefault();
        //     $slider.trigger('prev.owl.carousel');
        // });
        // $nextBtn.on('click', function(e) {
        //     e.preventDefault();
        //     $slider.trigger('next.owl.carousel');
        // });
    });
});
